/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSignRequestData,
  CreateSignRequestWithTemplateData,
  ErrorResponse,
  InternalServerErrorResponse,
  NotFoundErrorResponse,
  SignRequest,
  SignRequestUpdate,
  UnauthorizedErrorResponse,
  UpdateSignRequestDto,
  ValidationErrorResponse,
} from '../models/index';
import {
    CreateSignRequestDataFromJSON,
    CreateSignRequestDataToJSON,
    CreateSignRequestWithTemplateDataFromJSON,
    CreateSignRequestWithTemplateDataToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    InternalServerErrorResponseFromJSON,
    InternalServerErrorResponseToJSON,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    SignRequestFromJSON,
    SignRequestToJSON,
    SignRequestUpdateFromJSON,
    SignRequestUpdateToJSON,
    UnauthorizedErrorResponseFromJSON,
    UnauthorizedErrorResponseToJSON,
    UpdateSignRequestDtoFromJSON,
    UpdateSignRequestDtoToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface SignRequestControllerCreateSignRequestRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    document: Blob;
    data: CreateSignRequestData;
    appendix?: Array<Blob>;
}

export interface SignRequestControllerCreateSignRequestWithTemplateRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    data: CreateSignRequestWithTemplateData;
    appendix?: Array<Blob>;
}

export interface SignRequestControllerGetDocumentRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    id: string;
    documentId: string;
}

export interface SignRequestControllerGetDocumentsRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    id: string;
    responseFormat: SignRequestControllerGetDocumentsResponseFormatEnum;
}

export interface SignRequestControllerGetSignRequestRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    id: string;
}

export interface SignRequestControllerGetSignRequestWithFiltersRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    fromDate: string;
    customField: string;
}

export interface SignRequestControllerUpdateSignRequestRequest {
    x_countrycode: string;
    x_bucode: string;
    x_locale: string;
    x_request_id: string;
    id: string;
    UpdateSignRequestDto: UpdateSignRequestDto;
}

/**
 * 
 */
export class SignRequestsApi extends runtime.BaseAPI {

    /**
     * Create a sign request
     */
    async signRequestControllerCreateSignRequestRaw(requestParameters: SignRequestControllerCreateSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignRequest>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        if (requestParameters['document'] == null) {
            throw new runtime.RequiredError(
                'document',
                'Required parameter "document" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling signRequestControllerCreateSignRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        if (requestParameters['appendix'] != null) {
            requestParameters['appendix'].forEach((element) => {
                formParams.append('appendix', element as any);
            })
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', JSON.stringify(CreateSignRequestDataToJSON(requestParameters['data'])));
                    }

        const response = await this.request({
            path: `/api/v2/docusign/sign-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignRequestFromJSON(jsonValue));
    }

    /**
     * Create a sign request
     */
    async signRequestControllerCreateSignRequest(requestParameters: SignRequestControllerCreateSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignRequest> {
        const response = await this.signRequestControllerCreateSignRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a sign request from a template
     */
    async signRequestControllerCreateSignRequestWithTemplateRaw(requestParameters: SignRequestControllerCreateSignRequestWithTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignRequest>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerCreateSignRequestWithTemplate().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerCreateSignRequestWithTemplate().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerCreateSignRequestWithTemplate().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerCreateSignRequestWithTemplate().'
            );
        }

        if (requestParameters['data'] == null) {
            throw new runtime.RequiredError(
                'data',
                'Required parameter "data" was null or undefined when calling signRequestControllerCreateSignRequestWithTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['appendix'] != null) {
            requestParameters['appendix'].forEach((element) => {
                formParams.append('appendix', element as any);
            })
        }

        if (requestParameters['data'] != null) {
            formParams.append('data', JSON.stringify(CreateSignRequestWithTemplateDataToJSON(requestParameters['data'])));
                    }

        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignRequestFromJSON(jsonValue));
    }

    /**
     * Create a sign request from a template
     */
    async signRequestControllerCreateSignRequestWithTemplate(requestParameters: SignRequestControllerCreateSignRequestWithTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignRequest> {
        const response = await this.signRequestControllerCreateSignRequestWithTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single document for a sign request
     */
    async signRequestControllerGetDocumentRaw(requestParameters: SignRequestControllerGetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling signRequestControllerGetDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/{id}/documents/{documentId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a single document for a sign request
     */
    async signRequestControllerGetDocument(requestParameters: SignRequestControllerGetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.signRequestControllerGetDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get documents for a sign request
     */
    async signRequestControllerGetDocumentsRaw(requestParameters: SignRequestControllerGetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        if (requestParameters['responseFormat'] == null) {
            throw new runtime.RequiredError(
                'responseFormat',
                'Required parameter "responseFormat" was null or undefined when calling signRequestControllerGetDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseFormat'] != null) {
            queryParameters['responseFormat'] = requestParameters['responseFormat'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/{id}/documents`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get documents for a sign request
     */
    async signRequestControllerGetDocuments(requestParameters: SignRequestControllerGetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.signRequestControllerGetDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a sign request by ID
     */
    async signRequestControllerGetSignRequestRaw(requestParameters: SignRequestControllerGetSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignRequest>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerGetSignRequest().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerGetSignRequest().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerGetSignRequest().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerGetSignRequest().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling signRequestControllerGetSignRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignRequestFromJSON(jsonValue));
    }

    /**
     * Get a sign request by ID
     */
    async signRequestControllerGetSignRequest(requestParameters: SignRequestControllerGetSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignRequest> {
        const response = await this.signRequestControllerGetSignRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search sign requests by filter criteria
     */
    async signRequestControllerGetSignRequestWithFiltersRaw(requestParameters: SignRequestControllerGetSignRequestWithFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SignRequest>>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        if (requestParameters['fromDate'] == null) {
            throw new runtime.RequiredError(
                'fromDate',
                'Required parameter "fromDate" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        if (requestParameters['customField'] == null) {
            throw new runtime.RequiredError(
                'customField',
                'Required parameter "customField" was null or undefined when calling signRequestControllerGetSignRequestWithFilters().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = requestParameters['fromDate'];
        }

        if (requestParameters['customField'] != null) {
            queryParameters['customField'] = requestParameters['customField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SignRequestFromJSON));
    }

    /**
     * Search sign requests by filter criteria
     */
    async signRequestControllerGetSignRequestWithFilters(requestParameters: SignRequestControllerGetSignRequestWithFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SignRequest>> {
        const response = await this.signRequestControllerGetSignRequestWithFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a sign request
     */
    async signRequestControllerUpdateSignRequestRaw(requestParameters: SignRequestControllerUpdateSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignRequestUpdate>> {
        if (requestParameters['x_countrycode'] == null) {
            throw new runtime.RequiredError(
                'x_countrycode',
                'Required parameter "x_countrycode" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        if (requestParameters['x_bucode'] == null) {
            throw new runtime.RequiredError(
                'x_bucode',
                'Required parameter "x_bucode" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        if (requestParameters['x_locale'] == null) {
            throw new runtime.RequiredError(
                'x_locale',
                'Required parameter "x_locale" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        if (requestParameters['x_request_id'] == null) {
            throw new runtime.RequiredError(
                'x_request_id',
                'Required parameter "x_request_id" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        if (requestParameters['UpdateSignRequestDto'] == null) {
            throw new runtime.RequiredError(
                'UpdateSignRequestDto',
                'Required parameter "UpdateSignRequestDto" was null or undefined when calling signRequestControllerUpdateSignRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['x_countrycode'] != null) {
            headerParameters['x-countrycode'] = String(requestParameters['x_countrycode']);
        }

        if (requestParameters['x_bucode'] != null) {
            headerParameters['x-bucode'] = String(requestParameters['x_bucode']);
        }

        if (requestParameters['x_locale'] != null) {
            headerParameters['x-locale'] = String(requestParameters['x_locale']);
        }

        if (requestParameters['x_request_id'] != null) {
            headerParameters['x-request-id'] = String(requestParameters['x_request_id']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/docusign/sign-requests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSignRequestDtoToJSON(requestParameters['UpdateSignRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignRequestUpdateFromJSON(jsonValue));
    }

    /**
     * Update a sign request
     */
    async signRequestControllerUpdateSignRequest(requestParameters: SignRequestControllerUpdateSignRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignRequestUpdate> {
        const response = await this.signRequestControllerUpdateSignRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SignRequestControllerGetDocumentsResponseFormatEnum = {
    combined: 'combined',
    archive: 'archive',
    unknown_default_open_api: '11184809'
} as const;
export type SignRequestControllerGetDocumentsResponseFormatEnum = typeof SignRequestControllerGetDocumentsResponseFormatEnum[keyof typeof SignRequestControllerGetDocumentsResponseFormatEnum];
